import React from 'react';
import { motion } from 'framer-motion';
import { Card } from '../ui/Card';
import { SectionHeading } from '../ui/SectionHeading';
import { FileTextIcon, AwardIcon, XCircleIcon, BookOpenIcon, UserPlusIcon, ArrowRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const quickLinks = [{
  title: 'Annual Procurement Plan',
  description: 'View planned procurement activities for the year',
  icon: FileTextIcon,
  path: '/procurement/annual-plan'
}, {
  title: 'Contract Awards',
  description: 'Recently awarded contracts and their details',
  icon: AwardIcon,
  path: '/procurement/contract-awards'
}, {
  title: 'Procurement Manual',
  description: 'Guidelines, policies, and procedures',
  icon: BookOpenIcon,
  path: '/procurement/manual'
}, {
  title: 'Supplier Registration',
  description: 'Register your company to participate in tenders',
  icon: UserPlusIcon,
  path: '/procurement/supplier-registration'
}];
export function ProcurementQuickLinks() {
  return <section className="py-20 bg-ivory" data-id="element-152">
      <div className="max-w-7xl mx-auto px-4" data-id="element-153">
        <SectionHeading title="Procurement Resources" subtitle="Quick access to essential procurement information and services" centered data-id="element-154" />

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12" data-id="element-155">
          {quickLinks.map((link, index) => {
          const Icon = link.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-156">
                <Link to={link.path} data-id="element-157">
                  <Card hover className="h-full text-center" data-id="element-158">
                    <div className="w-16 h-16 bg-au-green-light rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-159">
                      <Icon size={32} className="text-au-green" data-id="element-160" />
                    </div>
                    <h3 className="text-lg font-bold text-charcoal mb-2" data-id="element-161">
                      {link.title}
                    </h3>
                    <p className="text-sm text-gray-600 mb-4" data-id="element-162">
                      {link.description}
                    </p>
                    <div className="flex items-center justify-center gap-1 text-au-green font-medium text-sm" data-id="element-163">
                      <span data-id="element-164">Learn More</span>
                      <ArrowRightIcon size={16} data-id="element-165" />
                    </div>
                  </Card>
                </Link>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}